'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _immutable = require('immutable');

var CompanyOverview = new _immutable.Record({
	name: '',
	overview: '',
	website: '',
	avatar: '',
	location: new _immutable.Map({
		id: 0,
		name: '',
		number: '',
		addressLine1: '',
		addressLine2: '',
		city: '',
		state: '',
		zip: '',
		country: '',
		longitude: 0,
		latitude: 0,
		clientCompanyId: 0
	}),
	followedByUser: false,
	blockedByUser: false,
	blockCompanyRequested: false,
	blockCompanyRequestError: '',
	followedByUserRequested: false,
	followedByUserRequestError: '',
	yearFounded: 0,
	createdOn: '',
	workInviteSentToUserId: '',
	performWorkForClients: false,
	inVendorSearch: false,
	ratings: {},
	jobFunctions: new _immutable.List(),
	skills: new _immutable.List(),
	employees: 0,
	buyerScorecard: new _immutable.Map({
		paidWorkCount: 0,
		avgTimeToApproveWorkInDays: 0,
		avgTimeToPayWorkInDays: 0,
		satisfactionRate: 0
	}),
	talentPools: new _immutable.List()
});

var _default = CompanyOverview;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(CompanyOverview, 'CompanyOverview', 'src/reducers/records/CompanyOverview.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/reducers/records/CompanyOverview.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/reducers/records/CompanyOverview.js
// module id = MTq+
// module chunks = 62 63